import { DEFAULT_CHAIN_ID } from 'config'
import useContracts from 'hooks/mint/useContracts'
import { useSmartContractReadCall } from 'hooks/react-query-typechain/useSmartContractReadCall'
import { useContractAddresses } from './useContractAddresses'

const useGobblerAssignedId = (gobblerTokenId: string | null | undefined) => {
  const chainId = DEFAULT_CHAIN_ID
  const contractAddresses = useContractAddresses(chainId)

  const [gobblersContract] = useContracts(chainId)

  const gobblerOnChainQuery = useSmartContractReadCall(gobblersContract, 'getGobblerData', {
    callArgs: [gobblerTokenId!],
    enabled: !!gobblerTokenId,
  })

  if (gobblerTokenId && parseInt(gobblerTokenId, 10) > 9990) {
    return gobblerTokenId
  }

  return gobblerOnChainQuery.data?.[1]?.toString()
}

export { useGobblerAssignedId }
